

































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import PathPicker from './PathPicker.vue';
import {validationMixin} from 'vuelidate';
import {numeric, minValue} from 'vuelidate/lib/validators';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';

const greaterThan = (value: string, vm: any) => (parseInt(value, 10) >= parseInt(vm.minLength, 10) || vm.maxLength === '' || vm.minLength === '');
@Component({
	components: {
		PathPicker,
		HelpIcon
	},
	mixins: [
		validationMixin
	],
	validations: {
		minLength: {
			numeric,
			minValue: minValue(0),
		},
		maxLength: {
			numeric,
			minValue: minValue(0),
			greaterThan
		},
	}
})
export default class InputPatternEditor extends Vue {
	@Prop() public value: string;
	@Prop({default: true}) public showType: boolean;

	public selectedType = '';
	public minLength = '';
	public maxLength = '';

	public availablePatternTypes: { [key: string]: string } = {
		'Any': '.',
		'Alphanumeric': '[a-zA-Z0-9]',
		'Letters Only': '[a-zA-Z]',
		'Numbers Only': '[0-9]',
		'Decimal': '(\\d+(\\.\\d{0,2})?|\\.?\\d{1,2})'
	};

	@Watch('value', { immediate: true })
	public onValueChanged(value: string, previous: string) {
		this.parsePattern();

		this.$v.$touch();
		this.patternChanged();
	}

	public parsePattern() {
		if (!this.value || this.value.length === 0) {
			this.selectedType = 'Any';
			return;
		}
		this.selectedType = this.getSelectedType() || 'Any';

		if (this.canBeAnyLength()) {
			this.minLength = '';
			this.maxLength = '';
		} else if (this.value.indexOf('{') > -1) {
			const openingBrace = this.value.indexOf('{') + 1;
			const closingBrace = this.value.indexOf('}');
			const lengths = this.value.substring(openingBrace, closingBrace).split(',');

			this.minLength = lengths[0];
			this.maxLength = lengths[1];
		}
	}

	public buildPattern() {
		let pattern: string = `${this.availablePatternTypes[this.selectedType]}`;
		if (this.selectedType === 'Decimal') {
			pattern = this.buildDecimalPattern(pattern);
		} else {
			if (this.minLength.length === 0 && this.maxLength.length === 0) {
				pattern += '+';
			} else {
				if (this.minLength.length === 0) {
					pattern += `{1,${this.maxLength}}`;
				} else {
					pattern += `{${this.minLength},${this.maxLength}}`;
				}
			}
		}
		pattern = `^${pattern}$`;

		return pattern;
	}

	public patternChanged() {
		const newPattern = this.buildPattern();
		this.$emit('updated', { pattern: newPattern, invalid: this.$v.$invalid });
	}

	private getSelectedType() {
		const keys = Object.keys(this.availablePatternTypes);
		keys.shift();
		return keys.find(key => this.value.indexOf(this.availablePatternTypes[key]) > -1);
	}

	private canBeAnyLength() {
		if (this.isRegexEndedWithPlusSymbol()) {
			return true;
		} else if (this.selectedType === 'Decimal') {
			return this.canDecimalBeAnyLength();
		}
		return false;
	}

	private isRegexEndedWithPlusSymbol() {
		const regExWithoutStartEndLineCharacters = this.stripLineStartAndEndCharacters(this.value);
		return regExWithoutStartEndLineCharacters.endsWith('+');
	}

	private canDecimalBeAnyLength() {
		const regExWithoutStartEndLineCharacters = this.stripLineStartAndEndCharacters(this.value);
		return this.isRegexDefaultDecimalRegex(regExWithoutStartEndLineCharacters);
	}

	private isRegexDefaultDecimalRegex(regex: string) {
		return this.availablePatternTypes.Decimal === regex;
	}

	private stripLineStartAndEndCharacters(input: string) {
		if (input.startsWith('^') && input.endsWith('$')) {
			return input.substring(1, input.length - 1);
		}
		return input;
	}

	private buildDecimalPattern(pattern: string) {
		if (this.minLength.length || this.maxLength.length) {
			if (this.minLength.length === 0) {
				pattern = `(?=^.{1,${this.maxLength}}$)${pattern}`;
			} else {
				pattern = `(?=^.{${this.minLength},${this.maxLength}}$)${pattern}`;
			}
		}
		return pattern;
	}


}
